exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.terms-container li, .terms-container ol {*/\n/*    line-height:170%;*/\n/*    list-style: revert;*/\n/*}*/\n.terms-scope * {\n  line-height: revert;\n  list-style: revert;\n}\n.terms-scope .content-box {\n  padding: 1rem !important;\n}\n.terms-scope .terms-container ol {\n  margin: 0;\n}\n/*.title-head{margin-top: 0;}*/\n/*.terms-para{padding-bottom:2rem;}*/\n/*.terms-para:last-child{padding-bottom:0;}*/\n/*.terms-para * {line-height:170%;}*/\n/*.terms-para ul{padding-left:1rem;}*/\n/*.terms-para ul li{list-style:decimal;padding:0 0 1rem .5rem;}*/\n/*.terms-para ul li:last-child{padding-bottom:0;}*/\n/*.terms-para>p{padding-bottom:1rem;}*/\n/*.terms-para>p:last-child{padding-bottom:0;}*/\n/*h4.terms-title{font-size:1rem;padding-bottom:1rem;color:#608197;}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f5962b4","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Terms.vue
// module id = w3U4
// module chunks = 2 3 4 5 6